import React from 'react'
import { GoogleMap, Marker, withGoogleMap, withScriptjs } from 'react-google-maps'
import mapMarker from '../../assets/mapMarker.svg'
import openInNewTab from '../../utils/openInNewTab'

export const mapsApiUrl = 'https://www.google.com/maps/search/?api=1&query='
export const iceBlue = [
  {
    stylers: [
      {
        hue: '#2c3e50'
      },
      {
        saturation: 250
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        lightness: 50
      },
      {
        visibility: 'simplified'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  }
]

const openMap = (urlParams) => () => {
  openInNewTab(`${mapsApiUrl}${urlParams.join('+')}`)
}

export const LocationMap = ({ geoloc, isMarkerShown, urlParams }) => (
  <GoogleMap
    defaultZoom={14}
    center={geoloc}
    defaultOptions={{ styles: iceBlue }}
  >
    { isMarkerShown && <Marker position={geoloc} options={{ icon: mapMarker }} onClick={openMap(urlParams)} /> }
  </GoogleMap>
)

export default withScriptjs(withGoogleMap(LocationMap))
